<template>
  <Modal :show="true" @close-modal="$emit('close-cancel-modal')">
    <div class="tw-max-w-[390px]">
      <img
        src="https://res.cloudinary.com/djalafcj9/image/upload/v1672925287/getequityV2/error_info_dz5hnk.png"
        class="tw-w-[84px] tw-h-[84px] tw-rounded-full tw-mx-auto tw-mb-4"
      />
      <h1
        class="tw-font-bold tw-text-xl tw-text-secondary tw-max-w-[243px] tw-mx-auto tw-text-center tw-mb-4"
      >
        {{ modalHeading }}
      </h1>

      <p
        class="tw-text-base tw-text-[#323E67] tw-text-center tw-max-w-[306px] tw-mx-auto"
      >
        {{ modalText }}
      </p>
      <div class="tw-flex tw-gap-x-4 tw-mt-16">
        <button
          @click="$emit('close-cancel-modal')"
          class="tw-rounded tw-w-full tw-w-1/2 tw-bg-[#E6EDFF] tw-font-CircularStd-medium tw-font-medium tw-text-secondary"
        >
          No
        </button>
        <div class="tw-w-full tw-w-1/2">
          <BtnComponent title="Yes" @click="$emit('confirm-cancel')" />
        </div>
      </div>
    </div>
  </Modal>
</template>

<script setup>
  import Modal from "@/components/general/Modal";
  import BtnComponent from "@/components/general/BtnComponent";
  import { useStore } from "vuex";
  import { computed } from "vue";
  defineEmits(["close-cancel-modal", "confirm-cancel"]);

  const store = useStore();

  const { type } = defineProps({
    type: {
      type: String,
      required: true,
    },
  });
  const modalHeading = computed(() =>
    type === "Request"
      ? "This will cancel your SPV request"
      : "This will delete this SPV from your list."
  );
  const modalText = computed(() =>
    type === "Request"
      ? "Your SPV request will be cancelled and removed from your SPV request list. Do you want to proceed?"
      : "Your SPV will be deleted and removed from your SPV list. Do you want to proceed?"
  );
</script>

<style lang="scss" scoped></style>
